module.exports = __webpack_public_path__ + "img/cuidado_cemiterio_icone.d89acd62.png";